import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Mail, Image as ImageIcon, QrCode, Users, Linkedin, Globe } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide14Channels({
  index
}: SlideProps) {
  const channels = [{
    icon: MessageCircle,
    label: 'WhatsApp'
  }, {
    icon: Mail,
    label: 'Email'
  }, {
    icon: ImageIcon,
    label: 'Banner'
  }, {
    icon: QrCode,
    label: 'Congress QR'
  }, {
    icon: Users,
    label: 'Rep follow-up'
  }, {
    icon: Linkedin,
    label: 'LinkedIn'
  }, {
    icon: Globe,
    label: 'Website'
  }, {
    icon: Globe,
    label: 'Landing page'
  }];
  return <InteriorSlide surface data-id="element-293">
      <SlideHeader eyebrow="Channel-Agnostic Deployment" data-id="element-294">
        One campaign experience, multiple digital entry points
      </SlideHeader>

      <div className="flex-1 min-h-0 flex flex-col items-center justify-center max-w-5xl mx-auto w-full" data-id="element-295">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed mb-[clamp(1.5rem,3vw,2.5rem)] text-center max-w-3xl flex-shrink-0" data-id="element-296">
          The same Snakker campaign can be deployed across channels, making the
          content more efficient and the HCP experience more consistent.
        </motion.p>

        {/* Center hub */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="flex-shrink-0 rounded-2xl bg-[var(--brand)] text-white shadow-xl flex items-center justify-center text-center px-[clamp(1.5rem,3vw,2.5rem)] py-[clamp(0.85rem,1.6vw,1.25rem)] mb-[clamp(1rem,2vw,1.75rem)]" data-id="element-297">
          <span className="text-[clamp(0.9rem,1.4vw,1.15rem)] font-bold uppercase tracking-wider leading-tight" data-id="element-298">
            One Snakker Campaign
          </span>
        </motion.div>

        {/* Connector */}
        <div className="h-[clamp(1rem,2vw,1.75rem)] w-0.5 bg-[var(--brand)]/30 flex-shrink-0" data-id="element-299" />

        {/* Channel grid */}
        <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-[clamp(0.75rem,1.5vw,1.25rem)] mt-[clamp(1rem,2vw,1.75rem)]" data-id="element-300">
          {channels.map((channel, i) => {
          const Icon = channel.icon;
          return <motion.div key={channel.label} initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5 + i * 0.06,
            duration: 0.45
          }} className="bg-white rounded-xl border border-black/5 shadow-sm flex flex-col items-center justify-center gap-2 py-[clamp(1rem,1.8vw,1.5rem)] px-2 text-center" data-id="element-301">
                <div className="h-11 w-11 md:h-12 md:w-12 rounded-full bg-[var(--surface)] flex items-center justify-center text-[var(--brand)]" data-id="element-302">
                  <Icon className="h-5 w-5 md:h-6 md:w-6" data-id="element-303" />
                </div>
                <span className="text-[0.7rem] md:text-xs font-bold text-[var(--fg)] uppercase tracking-wide leading-tight" data-id="element-304">
                  {channel.label}
                </span>
              </motion.div>;
        })}
        </div>
      </div>
    </InteriorSlide>;
}